// extracted by mini-css-extract-plugin
export default {"actionItem":"rjMcL","listItem":"_2ZIzx","actionWrapper":"_2h4UN","actionText":"_3E8xY","sizeSmall":"_1_Z0n","icon":"dunYw","separator":"_3xWkS"};